import React from 'react';
import PropTypes from 'prop-types';
import { PolicyRow, Typography } from 'components/alf-design';
import { formats, customTypes } from 'utils';

const MortgageePaid = ({ billing, showCancellationData }) => {
  const paidInFull = !billing.outstandingBalance;
  const paymentStatus = paidInFull ? 'Paid in Full' : 'Pending Payment';

  return (
    <>
      <div className="grid mb-[16px]">
        <Typography id="status" type="caption1" component="span">
          Your policy is set up as mortgagee billed. For questions or assistance
          regarding your payments, please contact your mortgage company or your
          agent.
        </Typography>
        {billing.pastDueAmount > 0 && (
          <div className="bg-legacy-errorBackground border border-legacy-errorBorder p-[13px] rounded-[8px]">
            <Typography id="pastDueAmount" type="error" component="span">
              Your last installment was not paid in full.
            </Typography>
          </div>
        )}
      </div>

      <div>
        {showCancellationData && (
          <div className="grid gap-[8px]">
            <Typography type="error" component="span">
              <b>Cancellation Date </b>
            </Typography>
            <Typography id="cancellationDate" type="error" component="span">
              {billing.cancellationDate}
            </Typography>
          </div>
        )}
        <div className="grid grid-rows-2 gap-[8px]">
          <div className="grid grid-cols-2 ">
            <PolicyRow label="Mortgage Company Name" value={billing.payor} />
            <PolicyRow label="Payment Status" value={paymentStatus} />
          </div>
          <div className="grid grid-cols-2">
            <PolicyRow
              label={paidInFull ? 'Amount Paid' : 'Amount Due'}
              value={formats.moneyFormat(
                paidInFull ? billing.amountPaid : billing.outstandingBalance,
              )}
            />

            {((paidInFull && !!billing.paidDate) ||
              (!paidInFull &&
                billing.currentDueAmount > 0 &&
                !!billing.currentDueDate)) && (
              <PolicyRow
                label={paidInFull ? 'Paid Date' : 'Due Date'}
                value={formats.dateFormat(
                  paidInFull ? billing.paidDate : billing.currentDueDate,
                )}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

MortgageePaid.propTypes = {
  billing: customTypes.billing,
  showCancellationData: PropTypes.bool,
};

export default MortgageePaid;
